import { graphql } from "react-relay";
import { SuggestionActionAutopilot } from "./suggestion-action-autopilot";
import { SuggestionActionConfigSettings } from "./suggestion-action-config-settings";
import { SuggestionActionDecline } from "./suggestion-action-decline";
import { SuggestionActionFyi } from "./suggestion-action-fyi";
import { SuggestionActionInvite } from "./suggestion-action-invite";
import { SuggestionActionRemoveAttendee } from "./suggestion-action-remove-attendee";
import { SuggestionActionRequestToMove } from "./suggestion-action-request-to-move";
import { SuggestionActionReschedule } from "./suggestion-action-reschedule";
import { SuggestionActionViewMeeting } from "./suggestion-action-view-meeting";
import { SuggestionActionViewProfile } from "./suggestion-action-view-profile";
import { SuggestionActionViewTeamDashboard } from "./suggestion-action-view-team-dashboard";

export const suggestionActionFragments = {
  org: graphql`
    fragment SuggestionAction_org on Org {
      ...SuggestionActionInvite_org
      ...SuggestionActionAutopilot_org
      ...SuggestionActionConfigSettings_org
      experiments
    }
  `,
  feedSuggestion: graphql`
    fragment SuggestionAction_feedSuggestion on FeedSuggestion {
      id
      suggestionPayload {
        __typename
        ... on SuggestionResultChromeExtensionTipPayload {
          tipType
        }
        ... on SuggestionResultMissingUserConfigurationPayload {
          configurationType
        }
      }
      primaryAction {
        display
        isPrimary
        type
        payload {
          __typename
          ... on SuggestionActionAutopilotPayload {
            ...SuggestionActionAutopilot_payload
          }
          ... on SuggestionActionConfigureSettingsPayload {
            ...SuggestionActionConfigSettings_payload
          }
          ... on SuggestionActionDeclinePayload {
            ...SuggestionActionDecline_payload
          }
          ... on SuggestionActionFyiPayload {
            ...SuggestionActionFyi_payload
          }
          ... on SuggestionActionInvitePayload {
            ...SuggestionActionInvite_payload
          }
          ... on SuggestionActionRemoveAttendeePayload {
            ...SuggestionActionRemoveAttendee_payload
          }
          ... on SuggestionActionRequestToMovePayload {
            ...SuggestionActionRequestToMove_payload
          }
          ... on SuggestionActionReschedulePayload {
            ...SuggestionActionReschedule_payload
          }
          ... on SuggestionActionViewMeetingPayload {
            ...SuggestionActionViewMeeting_payload
          }
          ... on SuggestionActionViewProfilePayload {
            ...SuggestionActionViewProfile_payload
          }
          ... on SuggestionActionViewTeamDashboardPayload {
            ...SuggestionActionViewTeamDashboard_payload
          }
        }
      }
    }
  `,
};
